import { clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// tailwind-merge doesn't know about our custom fontSize scale (tailwind.config.js),
// so it was misreading e.g. "text-label-md" as a text-COLOR utility (since it
// doesn't recognize the size name) and dropping earlier color classes like
// "text-white" as a false "conflict" — buttons ended up with invisible text.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        {
          text: [
            "display-xl", "display-lg", "display-md",
            "heading-xl", "heading-lg", "heading-md", "heading-sm",
            "body-lg", "body-md", "body-sm",
            "label-lg", "label-md", "label-sm",
          ],
        },
      ],
    },
  },
});

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
